import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.readonly)?_c(VTextarea,_vm._g(_vm._b({class:_vm.customData.class},'v-textarea',{..._vm.$props, ..._vm.customData.props},false),_vm.$listeners),[_vm._t("default")],2):_c('w-read-only-text-field',_vm._g(_vm._b({},'w-read-only-text-field',_vm.$props,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }